import { Lead } from '../../api/interfaces'
import { CountryCode } from 'libphonenumber-js'

export const getCompanyCountryCodeFor = (lead: Lead) => {
    return lead.values?.CompanyAddress?.country?.toUpperCase() as CountryCode
}
